import IQOSUSAGE from '../../images/IQOS-usage.png';
import IQOSMyDevice from '../../images/IQOS-mydevice.png';
import Donut from '../../components/donut-chart';
import React from "react";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

function MyDeviceInfo() {
    return (
        <div>

            <div style={{
                font: 'Sintony',
                fontSize: '12px',
                lineHeight: '13px',
                color: '#475666',
                textAlign: 'center',
                fontWeight: '400',
                marginTop: '20px'
            }}>IQOS COMMITMENT PLAN</div>
            <div>
                <Donut />
            </div>

            <div style={{
                marginBottom: '50px'
            }}>
                <Row>
                    <Col style={{
                        textAlign: 'center',
                        font: 'Sintony',
                        fontSize: '13px',
                        lineHeight: '13px',
                        color: '#475666',
                        fontWeight: '400'

                    }}>
                        USAGE
                    </Col>
                    <Col style={{
                        textAlign: 'center',
                        font: 'Sintony',
                        fontSize: '13px',
                        lineHeight: '13px',
                        color: '#475666',
                        fontWeight: '400'

                    }}>
                        MY DEVICE
                    </Col>
                </Row>
                <Row style={{
                    marginTop: '20px',
                    marginBottom: '20px'
                }}>
                    <Col style={{
                        textAlign: 'center'
                    }}>
                        <img src={IQOSUSAGE} style={{ width: '108px', height: '78px' }} alt="" />
                    </Col>
                    <Col style={{
                        textAlign: 'center'
                    }}>
                        <img src={IQOSMyDevice} style={{ width: '108px', height: '100px' }} alt="" />
                    </Col>
                </Row>
                <Row>
                    <Col style={{
                        textAlign: 'center',
                        font: 'Sintony',
                        fontSize: '12px',
                        lineHeight: '13px',
                        color: '#475666',
                        fontWeight: '400'

                    }}>
                        IQOS USAGE THIS WEEK

                    </Col>
                    <Col style={{
                        textAlign: 'center',
                        font: 'Sintony',
                        fontSize: '12px',
                        lineHeight: '13px',
                        color: '#475666',
                        fontWeight: '400'

                    }}>
                        DEVICE LIFE
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default MyDeviceInfo;